import GameManager from '@/assets/js/game/GameManager';

export const setSound = (state, val) => {
  state.isSound = val;
};

export const setScore = (state, value) => {
  state.score = value;
};

export const addScore = (state, value) => {
  state.score += value;
};

export const resetScore = state => {
  state.score = 0;
};

export const upLife = (state, value = 1) => {
  state.life += value;
};

export const downLife = (state, value = 1) => {
  state.life -= value;
};

export const resetLife = (state, value = GameManager.maxLife) => {
  state.life = value;
};
